import { ReactComponent as UnitedKingdomFlagIcon } from '../../assets/united-kingdom-flag.svg';
import { ReactComponent as SerbianFlagIcon } from '../../assets/serbian-flag.svg';
import { ReactComponent as PortugalFlagIcon } from '../../assets/portugal-flag.svg';
import { ReactComponent as VietnamFlagIcon } from '../../assets/vietnam-flag.svg';
import { LanguageCodeDisplayEnum, LanguageCodeEnum } from '../enums/common.enum';
import React from 'react';

/**
 * Codes, flags and each language's own name for itself.
 *
 * `nativeName` is deliberately not translated: a language menu lists "Srpski" and "English"
 * whatever the interface is in, so someone who cannot read the current one can still find
 * theirs. The translated names ("Serbian" read in English) live in the locale files under
 * `language.names.*`, for the content-language selector.
 */
export const languageMeta: Record<
  LanguageCodeEnum,
  { shortLabel: string; nativeName: string; Flag: React.FC<React.SVGProps<SVGSVGElement>> }
> = {
  [LanguageCodeEnum.ENG]: {
    shortLabel: LanguageCodeDisplayEnum.ENG,
    nativeName: 'English',
    Flag: UnitedKingdomFlagIcon
  },
  [LanguageCodeEnum.SRB]: {
    shortLabel: LanguageCodeDisplayEnum.SRB,
    nativeName: 'Srpski',
    Flag: SerbianFlagIcon
  },
  [LanguageCodeEnum.PRT]: {
    shortLabel: LanguageCodeDisplayEnum.PRT,
    nativeName: 'Português',
    Flag: PortugalFlagIcon
  },
  [LanguageCodeEnum.VNM]: {
    shortLabel: LanguageCodeDisplayEnum.VNM,
    nativeName: 'Tiếng Việt',
    Flag: VietnamFlagIcon
  }
};
